import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { SparkleIcon, ArrowDown } from '../components/ui/Icons';
import { Button } from '../components/ui/button';

export default function HomePage() {
    const { user } = useAuth();

    return (
        <div className="min-h-screen flex flex-col items-center justify-center text-center px-6" data-testid="home-page">
            {/* Sparkle decoration */}
            <SparkleIcon className="w-8 h-12 text-foreground/60 mb-8" />
            
            {/* Main heading */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-normal mb-4">
                Vítejte ve webovém žurnálu!
            </h1>
            
            {/* Logo name in italic */}
            <p className="text-3xl md:text-4xl italic mb-8">
                Listovna
            </p>

            {/* Auth buttons */}
            {!user && (
                <div className="flex flex-col sm:flex-row gap-4 mb-12">
                    <Link to="/registrace">
                        <Button 
                            variant="outline" 
                            className="min-w-[180px] italic text-lg py-6"
                            data-testid="cta-register"
                        >
                            Založit účet
                        </Button>
                    </Link>
                    <Link to="/prihlaseni">
                        <Button 
                            variant="ghost" 
                            className="min-w-[180px] italic text-lg py-6"
                            data-testid="cta-login"
                        >
                            Přihlásit se
                        </Button>
                    </Link>
                </div>
            )}

            {user && (
                <p className="text-lg italic text-muted-foreground mb-12">
                    Vítejte zpět, {user.name}
                </p>
            )}
            
            {/* Arrow pointing down */}
            <ArrowDown className="w-8 h-16 text-foreground/60 mb-12" />
            
            {/* Navigation links */}
            <nav className="flex flex-col gap-4">
                <Link 
                    to="/o-projektu" 
                    className="text-2xl md:text-3xl italic hover:underline underline-offset-4"
                    data-testid="nav-o-projektu"
                >
                    O projektu
                </Link>
                <Link 
                    to="/povidky" 
                    className="text-2xl md:text-3xl italic hover:underline underline-offset-4"
                    data-testid="nav-povidky"
                >
                    Povídky
                </Link>
                <Link 
                    to="/autori" 
                    className="text-2xl md:text-3xl italic hover:underline underline-offset-4"
                    data-testid="nav-autori"
                >
                    Autoři
                </Link>
            </nav>
        </div>
    );
}
